// extracted by mini-css-extract-plugin
export default {"login":"styles_login__FFNzm","heading":"styles_heading__D21WM","inputGroup":"styles_inputGroup__pEteg","inputLabel":"styles_inputLabel__iv5+x","inputText":"styles_inputText__Mdm5H"};